import styled from 'styled-components'
import { Typography, Form } from 'antd'

const { Text } = Typography

export const PatientMessageHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const SectionTitle = styled(Text)`
    display: block;
    margin-bottom: 10px;
`

export const AdjustmentFormItem = styled(Form.Item)`
    margin-top: 20px;
`

export const ConsultationForm = styled(Form)`
    display: flex;
    flex-direction: column;
    gap: 10px;
`
